import * as customerFraudRating from '../constants/customerFraudRating';

export const getCustomerFraudRatingProperties = (fraudRating) => {
  let properties = {};

  switch (fraudRating) {
    case customerFraudRating.HIGH_RISK:
      properties = {
        label: 'High Risk',
        icon: 'small-alert-triangle',
        iconColor: 'light-error-90',
        iconBackgroundColor: 'light-error-30',
      };
      break;
    case customerFraudRating.LOW_RISK:
      properties = {
        label: 'Low Risk',
        icon: 'small-check-circle',
        iconColor: 'light-success-90',
        iconBackgroundColor: 'light-success-30',
      };
      break;
    case customerFraudRating.UNCERTAIN_RISK:
      properties = {
        label: 'Uncertain Risk',
        icon: 'small-help-question-circle',
        iconColor: 'light-neutral-90',
        iconBackgroundColor: 'light-neutral-30',
      };
      break;
    default:
      break;
  }

  return properties;
};
